var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChargeCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_553_26667)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74997 1.5H14V1.89699e-06H1.99997V1.5H7.24997L7.24997 12.664L3.49997 13.599V12.2654C4.51424 11.9469 5.24997 10.9993 5.24997 9.87988C5.24997 8.49917 4.13068 7.37988 2.74997 7.37988C1.36926 7.37988 0.249968 8.49917 0.249968 9.87988C0.249968 10.9993 0.985691 11.9469 1.99997 12.2654L1.99997 13.973L0.0561523 14.4576L0.419035 15.9131L15.9438 12.0423L15.5809 10.5869L14 10.9811V9.63555C15.0142 9.31698 15.75 8.36941 15.75 7.25C15.75 5.86929 14.6307 4.75 13.25 4.75C11.8693 4.75 10.75 5.86929 10.75 7.25C10.75 8.36941 11.4857 9.31698 12.5 9.63555V11.3551L8.74997 12.29V1.5ZM13.25 6.25C13.8023 6.25 14.25 6.69772 14.25 7.25C14.25 7.80229 13.8023 8.25 13.25 8.25C12.6977 8.25 12.25 7.80229 12.25 7.25C12.25 6.69772 12.6977 6.25 13.25 6.25ZM2.74997 8.87988C3.30225 8.87988 3.74997 9.3276 3.74997 9.87988C3.74997 10.4322 3.30225 10.8799 2.74997 10.8799C2.19768 10.8799 1.74997 10.4322 1.74997 9.87988C1.74997 9.3276 2.19768 8.87988 2.74997 8.87988Z",
    fill: "#197A56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_553_26667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeCode);
export default __webpack_public_path__ + "static/media/charge-code.64afa3597034fc498443e8edf4d115a0.svg";
export { ForwardRef as ReactComponent };